
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import BacInput from '@/components/BacInput.vue'
import BacButton from '../BacButton.vue'
import BacLazyImage from '@/components/BacLazyImage.vue'
import BacVideoPlayer from '@/components/BacVideoPlayer.vue'
import BacMultiselectWrapper from '../BacMultiselectWrapper.vue'
import Multiselect from 'vue-multiselect'

import { ChatAttachment } from '@/lib/chat/ChatAttachment'
import { DateUtils } from '../../lib/utils/DateUtils'
import { Team } from '../../lib/models/Team'
import { RatingChatMessage } from '@/lib/dtos/RatingChatMessage'
import { Game } from '../../lib/models/Game'

@Component({
  components: {
    BacInput,
    BacButton,
    BacLazyImage,
    BacVideoPlayer,
    BacMultiselectWrapper,
    Multiselect
  }
})
export default class RateChallengesTable extends Vue {
  @Prop({ default: () => [] }) headers!: [];
  @Prop({ default: () => [] }) items!: RatingChatMessage[];
  @Prop({ default: () => [] }) originalItems!: RatingChatMessage[]; // deep copy of items for filtering
  @Prop({ default: 20 }) itemsPerPage!: number;
  @Prop({ default: false }) unrate!: boolean;
  @Prop({ default: () => [] }) challenges!: Game[]
  @Prop({ default: '' }) search!: string

  teamsInRallyRound: Team[] = []
  teams: Team[] = []
  note = ''

  ChatAttachment = ChatAttachment;
  DateUtils = DateUtils

  get teamsInRallyRoundMultiselect () {
    return this.teamsInRallyRound.map(team => {
      return { id: team.id, name: `#${team.number} ${team.name}` }
    })
  }

  mounted () {
    this.loadTeamsInRallyRound()
  }

  searchFunction (value: any, query: string, item: any) {
    if (query === null) {
      return false
    }

    if (typeof value === 'string') {
      if (value.toString().toLowerCase().includes(query.toLowerCase())) {
        return true
      }
    }

    if (item.team) {
      if (item.team.number.includes(query)) {
        return true
      }
      if (item.team.name.toLowerCase().includes(query.toLowerCase())) {
        return true
      }
    }

    if (item.user.firstname.toLowerCase().includes(query.toLowerCase())) {
      return true
    }
    if (item.user.lastname.toLowerCase().includes(query.toLowerCase())) {
      return true
    }
    if (this.challengeNameFromItem(item).toLowerCase().includes(query.toLowerCase())) {
      return true
    }

    return false
  }

  challengeNameFromItem (item: RatingChatMessage): string {
    const challenge = this.challenges.find(challenge => challenge.id === item.gameId)
    if (challenge && challenge.name) {
      return challenge.name
    } else {
      return ''
    }
  }

  itemNotesAsString (notes: any[]): string {
    if (!notes || notes.length === 0) {
      return 'Keine Notizen vorhanden'
    }
    return notes.map(note => note.note).join('\n')
  }

  @Watch('$store.state.PageURLRallyRound.rallyRound')
  async loadTeamsInRallyRound () {
    if (this.$store.state.PageURLRallyRound.rallyRound.id) {
      this.teamsInRallyRound = await this.$store.state.PageURLRallyRound.rallyRound.getTeams()
    }
  }

  setPostId (postId: number) {
    this.$emit('setSelectedPostId', postId)
  }
}
